import { detectEmbedProvider } from '../media/embedProviders';

export const FADE_TYPES = {
  none: { label: 'Aucun', ms: 0 },
  fade_fast: { label: 'Rapide (200 ms)', ms: 200 },
  fade: { label: 'Standard (400 ms)', ms: 400 },
  fade_slow: { label: 'Lent (800 ms)', ms: 800 },
};

export function getFadeDurationMs(fadeType) {
  return FADE_TYPES[fadeType]?.ms ?? FADE_TYPES.fade.ms;
}

/** Durée d'affichage : un seul paramètre clair, en secondes — combien de
 *  temps la page de chargement reste visible avant de passer au site. */
export function resolveDisplayDurationMs(props) {
  const seconds = Math.max(0.5, Number(props?.durationSeconds) || 3);
  return seconds * 1000;
}

/** Au-delà, l'attente n'est plus une introduction : c'est une porte fermée. */
export const MAX_VIDEO_LOOPS = 10;

/** Sans métadonnées au bout de ce délai, la vidéo ne jouera pas : on repasse au chrono. */
export const VIDEO_METADATA_TIMEOUT_MS = 5000;

/** Marge au-delà de la durée théorique : un `ended` perdu ne fige pas l'écran. */
export const LOOPS_SAFETY_SLACK_MS = 2000;

/**
 * Peut-on compter les lectures de la vidéo ?
 *
 * Seulement sur un vrai fichier : un lien YouTube ou Vimeo n'est pas un fichier,
 * la balise `<video>` ne sait pas le lire et n'émettra jamais `ended`.
 */
export function canCountVideoLoops(props) {
  if (props?.mediaKind !== 'video') return false;
  const url = props?.mediaUrlVideo || '';
  if (!url) return false;
  return !detectEmbedProvider(url);
}

/**
 * Le mode de fin réellement applicable.
 *
 * `endMode` dit l'intention, mais le média a le dernier mot : demander « à la
 * fin de la vidéo » sur un spinner ou sur un embed retomberait sur un écran qui
 * ne se ferme jamais.
 */
export function resolveLoadingEndMode(props) {
  if (props?.endMode !== 'loops') return 'duration';
  return canCountVideoLoops(props) ? 'loops' : 'duration';
}

/** Nombre de lectures complètes, borné : entier entre 1 et {@link MAX_VIDEO_LOOPS}. */
export function resolveVideoLoops(props) {
  const loops = Math.round(Number(props?.videoLoops) || 1);
  if (!Number.isFinite(loops)) return 1;
  return Math.min(MAX_VIDEO_LOOPS, Math.max(1, loops));
}
